import React, { FunctionComponent } from 'react';
import styled from '@emotion/styled';
import { UnstyledButton } from '../Button';
import { screenMedium } from '../../../styles/theme/breakpoints';
import { rem } from '../../../styles/theme/layout';

interface Props {
  toggle: (isOpen: boolean) => void;
  isOpen: boolean;
}

const Menu = styled(UnstyledButton)`
  display: none;
  cursor: pointer;
  position: relative;
  outline: none;
  width: ${rem(20)};
  height: ${rem(20)};

  @media screen and (max-width: ${screenMedium}) {
    display: block;
  }
`;

const Lines = styled.span`
  &::after {
    content: '';
    top: ${rem(-10)};
  }

  &::before {
    content: '';
    top: ${rem(-15)};
  }

  &,
  &::after,
  &::before {
    position: absolute;
    display: block;
    transition: all 300ms ease-out;
    transform: rotate(0deg);
    border-radius: ${rem(5)};
    margin: 5px 0;
    background: #fff;
    width: ${rem(20)};
    height: ${rem(2)};
  }

  ${(props: Pick<Props, 'isOpen'>) =>
    props.isOpen &&
    `
    & {
      background: transparent;
    }

    &::before {
      transform: rotate(-45deg);
      top: ${rem(-10)};
    }

    &::after {
      top: ${rem(-10)};
      transform: rotate(45deg);
    }
  `}
`;

const HamburgerMenu: FunctionComponent<Props> = ({ toggle, isOpen }) => (
  <Menu onClick={() => toggle(!isOpen)}>
    <Lines isOpen={isOpen} />
  </Menu>
);

export default HamburgerMenu;
